export default __webpack_public_path__ + "static/media/Highlight1.bb657bcd.svg";